import { useFormikContext } from 'formik';
import { useCreateSelectOptions } from '../../hooks/useCreateSelectOptions';
import { Grid, GridRow, Select, SelectOptionType } from '@bp/ui-components';
import { MultiValue } from 'react-select';
import { useTranslation } from 'react-i18next';
import { FragmentType, getFragmentData, graphql } from 'client/gql';

const CourseFormTeachersFieldsDocument = graphql(`
  fragment CourseFormTeachersFields on Query {
    courseFormTeachersProfiles: profiles(
      where: {
        organization: { uuid: $organizationUuid }
        NOT: { rolesConnection_SOME: { Organization: { edge: { roleNames_INCLUDES: "STUDENT" } } } }
        rolesConnection_SOME: { Organization: { edge: { roleNames_INCLUDES: "TEACHER" } } }
      }
    ) {
      uuid
      __typename
      selectName
    }
  }
`);

type CourseFormTeachersProps = {
  query: FragmentType<typeof CourseFormTeachersFieldsDocument> | undefined;
};

export const CourseFormTeachers = <
  T extends {
    editors: string[];
  },
>({
  query,
}: CourseFormTeachersProps) => {
  const { t } = useTranslation();
  const fragment = getFragmentData(CourseFormTeachersFieldsDocument, query);

  const { setFieldValue, values, setFieldTouched } = useFormikContext<T>();

  const editorsSelectOpts = useCreateSelectOptions(fragment?.courseFormTeachersProfiles, 'uuid', 'selectName');

  return (
    <Grid>
      <GridRow>
        <Select
          label={t('rolesInOrganization.teacher_other')}
          value={[...editorsSelectOpts.filter((v) => values.editors.includes(v.value as string))]}
          options={editorsSelectOpts}
          onChange={async (event) => {
            const editorOptions = event as MultiValue<SelectOptionType>;
            await setFieldTouched('editors', true);
            await setFieldValue(
              'editors',
              editorOptions.map((value) => value.value as string),
            );
          }}
          name={'editors'}
          isSearchable
          isMulti
          isClearable
          menuPosition='fixed'
        />
      </GridRow>
    </Grid>
  );
};
